import Mask from './components/mask';
(function ($) {
	let filters = $('.filters-wrap');
	let caret = $('.filters i.fa');

	if (filters.hasClass('open')) filters.removeClass('open');

	$('.filters h3').on('click', function () {
		if (caret.hasClass('fa-chevron-down')) caret.removeClass('fa-chevron-down').addClass('fa-chevron-up');
		else caret.removeClass('fa-chevron-up').addClass('fa-chevron-down');

		filters.slideToggle(300);
	});

	if (window.hpyGlobals.isMobile) {
		$('.filters-wrap').hide();
	}
})(jQuery);

(function ($) {

	$('input.search-submit').on('click', function (e) {
		var searchInput = e.target.parentNode.querySelector('input.search-field');
		if (searchInput && searchInput.value.length === 0) {
			e.preventDefault();
		}
	});

	$('button.menu-toggle').on('click', toggleMenu);
	$('.menu_close').on('click', closeMenu);


	add_click_event();

	const mask = new Mask('navigation', {}, closeMenu);

	function toggleMenu() {
		if (document.body.classList.contains('menu-open')) {
			closeMenu();
		} else {
			openMenu();
		}
	}

	function openMenu() {
		document.body.classList.add('menu-open');
		mask.show();
	}

	function closeMenu() {
		document.body.classList.remove('menu-open');
		mask.hide();
	}

	function add_click_event() {
		$('.dropdown .menu_arr').each(function () {
			$(this).on('click', openDropdown);
		});
	}

	function remove_click_event() {
		$('.dropdown').each(function () {
			var $this = $(this);
			$this.find('.menu_arr').off('click');
			$this.find('.dropdown-menu').removeClass('open');
		});
	}

	function openDropdown(e) {
		e.preventDefault();
		if (!window.hpyGlobals.isBreakpoint('lg')) {
			return;
		}

		var $that = $(this).parents('.dropdown'),
			menuItem = $that.find('.dropdown-menu');

		$('.dropdown').each(function () {
			if ($that.get(0) !== $(this).get(0)) {
				// $(this).find('.dropdown-menu').removeClass('open');
				toggleMenuDropdown(false, $(this).find('.dropdown-menu').get(0));
			}
		});

		toggleMenuDropdown(!menuItem.hasClass('open'), menuItem.get(0));

	}

	function toggleMenuDropdown(open, toggle) {
		if (open) {
			console.log(toggle);
			toggle.style.height = 'auto';
			const height = toggle.offsetHeight;
			toggle.style.height = '0';

			gsap.to(toggle, {
				height: height,
				duration: 0.3,
				onStart: () => {
					toggle.classList.add('open');
				}
			});
		} else {
			gsap.to(toggle, {
				height: 0,
				duration: 0.3,
				onStart: () => {
					toggle.classList.remove('open');
				}
			});
		}
	}
})(jQuery);

(function () {
	var is_webkit = navigator.userAgent.toLowerCase().indexOf('webkit') > -1,
		is_opera = navigator.userAgent.toLowerCase().indexOf('opera') > -1,
		is_ie = navigator.userAgent.toLowerCase().indexOf('msie') > -1;

	if ((is_webkit || is_opera || is_ie) && document.getElementById && window.addEventListener) {
		window.addEventListener('hashchange', function () {
			var element = document.getElementById(location.hash.substring(1));

			if (element) {
				if (! /^(?:a|select|input|button|textarea)$/i.test(element.tagName))
					element.tabIndex = -1;

				element.focus();
			}
		}, false);
	}
})();